"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLHRElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLHRElementImpl
};
